<div class="bulk-upload-page">

  <div class="main-container">

    @if (!isSubmittedCase && hasEntitlement && massUploadGridConfigUrl) {
      <app-drag-and-drop-file-upload
        (fileDropped)="onFileDropped($event)"
        (invalidFile)="onInvalidFile($event)">
        <top-content>
          @if (gridEntryList.length && totalRowsToProcess === 0) {
            <h3 class="upload-overwrite-warning">
              <span class="material-symbols-outlined danger-icon">warning</span> Existing enrollments will be overwritten!
            </h3>
          }
        </top-content>
      </app-drag-and-drop-file-upload>
    }

    @if (errorMessage) {
      <div class="error-message" [class.submitted]="isSubmittedCase">
        <p>{{ errorMessage }}</p>
      </div>
    }
    
    <div class="edit-table-container" [hidden]="gridEntryList.length === 0 || totalRowsToProcess > 0">
      <div class="flex-table" #gridScrollContainer>
        <div class="flex-table-header">

          <!--
            STICKY HEADERS
          -->
          <div class="sticky-columns-container sticky">
            <div class="flex-table-row header-row">
              <div class="flex-table-cell header-cell action-cell">
                Actions
              </div>
              <div class="flex-table-cell header-cell status-cell">
                Status
              </div>
            </div>
          </div>

          <!--
            SCROLLABLE HEADERS
          -->
          <div class="normal-columns-container">
            <div class="flex-table-row header-row">
              @for (header of gridHeaders; track $index) {
                @if ($index > 0) {
                  <div class="flex-table-cell header-cell">{{ header }}</div>
                }
              }
            </div>
          </div>
        </div>

        <div class="flex-table-body" #tableBodyContainer>         

          <!--
            STICKY COLUMNS
          -->
          <div class="sticky-columns-container sticky" #stickyBodyViewport>
            @for (entryRow of gridEntryList; track trackByStateId(entryRow); let entryRowIndex = $index) {
              @if (entryRowIndex >= visibleStartIndex && entryRowIndex <= visibleEndIndex) {
                <div class="flex-table-row data-row" (click)="changeEditRow(entryRowIndex)">
                  <div class="flex-table-cell action-cell">
                    @if (!this.isSubmittedCase) {
                      <button class="action-menu-trigger" mat-icon-button [matMenuTriggerFor]="rowMenu" (click)="updateRowActions(entryRowIndex, $event)">
                        <span class="material-symbols-outlined">more_horiz</span>
                      </button>
                    }
                  </div>
                  <div class="flex-table-cell status-cell">
                    <!-- Mass Upload specific components don't use formConfig, but we have to set it to avoid errors/warnings -->
                    <ptl-entry-as-json [entryConfig]="entryRow[0]" [form]="gridFormMap[entryRowIndex].formGroups" [formConfig]="placeholderFormConfig"></ptl-entry-as-json>
                  </div>
                </div>
              }
              @else {
                <div class="flex-table-row"></div>
              }
            }
          </div>

          <!--
            SCROLLABLE COLUMNS
          -->
          <div class="normal-columns-container">
            @for (entryRow of gridEntryList; track trackByStateId(entryRow); let entryRowIndex = $index) {
              @if (entryRowIndex >= visibleStartIndex && entryRowIndex <= visibleEndIndex) {
                <div class="flex-table-row data-row" (click)="changeEditRow(entryRowIndex)">
                  @for (entry of entryRow; track $index; let entryIndex = $index) {
                    @if (entryIndex > 0) {
                      <div class="flex-table-cell {{entry.formControlAttributes.formControlName}}">
                        @if (entry.massUploadAttributes.editMode) {
                          <ptl-entry-as-json [entryConfig]="entry" [form]="gridFormMap[entryRowIndex].formGroups" [formConfig]="placeholderFormConfig"></ptl-entry-as-json>

                          @if (gridFormMap[entryRowIndex].formGroups[entry.formControlAttributes.connectPath].controls[entry.formControlAttributes.formControlName].invalid) {
                            <div class="current-form-error"><small>{{ getErrorString(entryRowIndex, entry) }}</small></div>
                          }
                        }
                        @else {
                          <div class="static-cell" [class.required]="gridFormMap[entryRowIndex].formGroups[entry.formControlAttributes.connectPath].controls[entry.formControlAttributes.formControlName].invalid">
                            {{ gridFormMap[entryRowIndex].formGroups[entry.formControlAttributes.connectPath].controls[entry.formControlAttributes.formControlName].value | massUploadValueMap:entry.massUploadAttributes.valueMapArray }}
                          </div>

                          @if (gridFormMap[entryRowIndex].formGroups[entry.formControlAttributes.connectPath].controls[entry.formControlAttributes.formControlName].invalid) {
                            <div class="current-form-error"><small>{{ getErrorString(entryRowIndex, entry) }}</small></div>
                          }
                        }
                      </div>
                    }
                  }
                </div>
              } @else {
                <div class="flex-table-row"></div>
              }
            }
          </div>
        </div>
      </div>

      <slot name="mug_extra_content"></slot>

      <div class="all-button-container">
        <div class="download-button">
          <button mat-raised-button color="secondary" (click)="downloadCurrentGridDataToExcel()">Download Grid As Excel</button>
        </div>

        @if (!isSubmittedCase) {
          <div class="save-button-container">
            <button class="margin-right" mat-raised-button color="secondary" (click)="saveGridForLater()">Save And Continue</button>
            <button mat-raised-button color="primary" (click)="submitAllApplications()">Submit Enrollments</button>
          </div>
        }
      </div>
    </div>
  </div>

  <mat-menu #rowMenu="matMenu">
    @for (action of actionMenuItems; track action.id) {
      <button mat-menu-item (click)="action.callback()" [class]="action.id">
        <span>{{ action.label }}</span>
      </button>
    }
  </mat-menu>

  @if (isLoading) {
    <div class="loading-mask">
      @if (totalRowsToProcess > 0) {
        <div class="loading-content">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Please wait while we process the enrollments ({{`${currentProcessedRows} of ${totalRowsToProcess}`}})</p>
          <mat-progress-bar mode="determinate" [value]="100 * currentProcessedRows/totalRowsToProcess"></mat-progress-bar>
        </div>
      }
      @else {
        <mat-spinner diameter="100"></mat-spinner>
      }
    </div>
  }
</div>